import * as React from 'react';
import { ClearDiv, Pullout, PulloutType } from '@aon/aon-tws-common-ui';
import ContentConstants from '../../../contentConstants';

export type ITextToSpeechWarningProps = {
	surveyCultures: string[];
	textToSpeechSupportedCultures: string[];
};

export class TextToSpeechWarning extends React.Component<ITextToSpeechWarningProps> {
	constructor(props: ITextToSpeechWarningProps) {
		super(props);
	}

	public render() {
		const { surveyCultures, textToSpeechSupportedCultures } = this.props;

		const unsupportedLanguages = surveyCultures.filter((x) => !textToSpeechSupportedCultures.includes(x));
		return (
			<>
				{textToSpeechSupportedCultures && unsupportedLanguages && unsupportedLanguages.length > 0 && (
					<>
						<ClearDiv height='10' />
						<Pullout type={PulloutType.Warning}>
							{ContentConstants.SURVEY_TEXT_TO_SPEECH_UNSUPPORTED_LANGUAGES_WARNING.replace(
								'{UnsupportedLanguages}',
								unsupportedLanguages.join(', '),
							)}
						</Pullout>
						<ClearDiv height='10' />
					</>
				)}
			</>
		);
	}
}
